import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import './App.scss';

import Menu from './components/Menu';
import HorseView from './components/HorseView';
import ConsignorView from './components/ConsignorView';
import VideoView from './components/VideoView';
import SaleView from './components/SaleView';
import Footer from './components/Footer';
import TopBar from './components/TopBar';
import FlashMessage from './components/FlashMessage';


function App() {
  return (
    <>
      <FlashMessage />
      <TopBar />
      <div className="App">
        <Router>
          <Menu />
          <Switch>
            <Route
                exact
                path="/"
                render={() => {
                    return (
                      <Redirect to="/sale" />
                    );
                }}
            />
            <Route exact path="/sale" children={
              <>
                <VideoView />
                <SaleView />
              </>
            } />
            <Route path="/consignor/:consignorID" children={
              <>
                <VideoView />
                <ConsignorView />
              </>
            } />
            <Route path="/:consignor/:hip" children={
              <>
                <VideoView />
                <HorseView />
              </>
            } />
          </Switch>
        </Router>      
      </div>
      <Footer />
    </>
  );
}

export default App;
